import { Panel } from 'primereact/panel';
import { Webhook } from 'lucide-react';
import { InputSwitch } from 'primereact/inputswitch';

import { formAction } from '../../../../constants';
import { ThirdPartyApiConfigurationProps } from '../Interface/thirdPartyApiConfiguration.interface';

const ThirdPartyApiConfiguration = ({
  action,
  widgetFormik,
}: ThirdPartyApiConfigurationProps) => {
  const headerTemplate = (
    <div className="flex align-items-center gap-2 text-sm font-medium text-gray-700">
      <Webhook className="text-primary text-sm w-1rem h-1rem" />
      <span className="text-sm font-bold text-gray-500">
        Third API Configuration
      </span>
    </div>
  );

  return (
    <Panel header={headerTemplate} className="w-full mb-2">
      <div className="flex align-items-center gap-2">
        <InputSwitch
          checked={widgetFormik.values.is_third_party === 1 ? true : false}
          onChange={event => {
            const thridParty = event?.value ? 1 : 0;
            widgetFormik.setFieldValue('is_third_party', thridParty);
          }}
          disabled={action === formAction.VIEW}
        />
        <div className="text-sm">Is this for a third-party API?</div>
      </div>
    </Panel>
  );
};

export default ThirdPartyApiConfiguration;
